import { Component, Input } from '@angular/core';
import { ProgressSpinnerMode, MatProgressSpinner } from '@angular/material/progress-spinner';
import { NgTemplateOutlet, NgClass } from '@angular/common';


@Component({
    selector: 'collaboration-ui-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    imports: [NgTemplateOutlet, MatProgressSpinner, NgClass]
})
export class SpinnerComponent {
  @Input() value = 100; // needed if use mode as determinate
  @Input() diameter = 35;
  @Input() mode: ProgressSpinnerMode = 'indeterminate';
  @Input() strokeWidth = 2;
  @Input() overlay = false;
  @Input() color = 'primary';
}
